import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { SendOTPToVerifyEmailRequestType } from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

interface UseSendOtpToVerifyEmailAPIInterface {
  sendOtpToVerifyEmailAPI: UseMutateAsyncFunction<
    void,
    unknown,
    SendOTPToVerifyEmailRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useSendOtpToVerifyEmailAPI = (): UseSendOtpToVerifyEmailAPIInterface => {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const sendOTPToVerifyEmail = (request: SendOTPToVerifyEmailRequestType) => {
    return ibUserAccountsAPIService.sendOTPToVerifyEmail(request);
  };

  const { mutateAsync, error, status } = useMutation(sendOTPToVerifyEmail, {
    mutationKey: ['sendOtpToVerifyEmailAPI']
  });

  return {
    sendOtpToVerifyEmailAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useSendOtpToVerifyEmailAPI };
